import React from 'react';
import { Ui }from '@einstein/schedule-platform';

import {
  Section,
  Container,
  Wrapper,
  TextContainer,
  Title,
  Description,
  ButtonContainer,
  ImageSection,
  Row,
  RowWrapper,
  IconImg
} from './styles';
const Image2x =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/FindYourDoctor/image@2x.png';
const calendarIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/calendar-rouded.svg';
const stethoscopeIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/estetoscopio.svg';

type EinsteinSchedulingProps = {
  handleSchedule: () => void;
  hasProductError?: boolean;
};

const FindYourDoctor = ({
  handleSchedule,
  hasProductError
}: EinsteinSchedulingProps) => {
  return (
    <Section id="encontre-seu-medico">
      <Container>
        <Wrapper>
          <TextContainer>
            <Title>Encontre seu médico</Title>
            <RowWrapper>
              <Row>
                <IconImg src={stethoscopeIcon} />
                <Description>
                  Encontre a especialidade médica de acordo com as suas
                  necessidades.
                </Description>
              </Row>
              <Row>
                <IconImg src={calendarIcon} />
                <Description>
                  Agende uma consulta presencial ou por telemedicina com
                  profissionais de excelência Einstein.
                </Description>
              </Row>
            </RowWrapper>
            <ButtonContainer>
              <Ui.Button
                title="Encontrar"
                disabled={!!hasProductError}
                onClick={handleSchedule}
              />
            </ButtonContainer>
          </TextContainer>
          <ImageSection src={Image2x} />
        </Wrapper>
      </Container>
    </Section>
  );
};

export default FindYourDoctor;
